/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 14:12:57
 * @LastEditTime: 2022-03-17 18:23:25
 * @LastEditors: wangshengqiang
 * @Description: 计划选择组件
 */
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { dispatch, useStore } from '@/store';
import './index.less';

const InsurancePlanSelect = props => {
  const {
    attrs
  } = props;
  const {
    dataSource = []
  } = attrs;
  const PLAN_ID = useStore('PLAN_ID');

  const handleChange = planItem => {
    if (planItem.value === PLAN_ID) return; // const currFormValues = getState('formValues');
    // const cacelFormValues = getState(`fvs._${planItem.value}`);

    const obj = {
      // [`fvs._${currentPlan}`]: currFormValues,
      currentPlan: planItem.value,
      PLAN_ID: planItem.value,
      insurancePlan: planItem,
      CLAUSE_CHECKED: false,
      premium: undefined,
      formValues: {
        trailElement: []
      }
    };
    dispatch(obj);
  };

  const cls1 = cn('select-plan-container', {
    'bg-fff': true,
    'select-plan-container-scroll': dataSource.length > 3
  });
  useEffect(() => {
    const planItem = dataSource.find(i => i.value === PLAN_ID) || dataSource[0];

    if (planItem) {
      dispatch({
        insurancePlan: planItem,
        currentPlan: planItem.value,
        PLAN_ID: planItem.value
      });
    }
  }, []);
  const firstI = dataSource[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "plan-select-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls1
  }, dataSource.map(item => {
    const cls = cn('select-plan-item', {
      'select-plan-item-active': PLAN_ID === item.value || !PLAN_ID && firstI.value === item.value,
      'select-plan-item-scroll': dataSource.length > 3
    });
    return /*#__PURE__*/React.createElement("div", {
      key: item.value,
      className: cls,
      onClick: () => {
        handleChange(item);
      }
    }, /*#__PURE__*/React.createElement("span", null, item.salesname));
  })));
};

export default InsurancePlanSelect;